module.exports = __webpack_public_path__ + "img/logo_pu.08d093df.png";